import { DOCUMENT_UPLOAD_DESTINATION_ALL } from './DocumentUploadDestinationModal.constants'

export function isDocumentUploadDestinationAll(destination) {
  return destination === DOCUMENT_UPLOAD_DESTINATION_ALL
}

export function getDocumentUploadDestinationRadioOptions(options) {
  return options.map(({ label, value }) => ({ id: value, label }))
}
